var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 30,
    viewBox: "0 0 100 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.7201 20.9579C99.7194 22.8009 99.1479 24.5985 98.0842 26.1035C97.0205 27.6086 95.5168 28.7473 93.7797 29.3632C92.8212 29.7069 91.8103 29.8817 90.7921 29.8796H75.9457V23.9487H90.7984C91.5916 23.9487 92.3523 23.6336 92.9132 23.0727C93.4741 22.5118 93.7892 21.7511 93.7892 20.9579C93.7892 20.1647 93.4741 19.4039 92.9132 18.843C92.3523 18.2822 91.5916 17.9671 90.7984 17.9671H83.4037C82.8907 17.9679 82.3787 17.9234 81.8735 17.834C81.3769 17.7481 80.8884 17.6209 80.4129 17.4538C78.4295 16.7503 76.7585 15.3682 75.6955 13.5519C74.6324 11.7356 74.2456 9.60194 74.6036 7.52804C74.9615 5.45415 76.041 3.57354 77.6513 2.21859C79.2617 0.863644 81.2992 0.121587 83.4037 0.12357H98.2564V6.0545H83.4037C83.011 6.0545 82.6221 6.13186 82.2592 6.28216C81.8964 6.43247 81.5666 6.65277 81.2889 6.93049C81.0112 7.20821 80.7909 7.53792 80.6406 7.90078C80.4903 8.26364 80.4129 8.65255 80.4129 9.04531C80.4129 9.43807 80.4903 9.82698 80.6406 10.1898C80.7909 10.5527 81.0112 10.8824 81.2889 11.1601C81.5666 11.4379 81.8964 11.6582 82.2592 11.8085C82.6221 11.9588 83.011 12.0361 83.4037 12.0361H90.7984C91.3102 12.0359 91.8211 12.0794 92.3255 12.166C92.8205 12.2511 93.3071 12.3794 93.7797 12.5494C95.5153 13.1677 97.0173 14.3076 98.0796 15.813C99.142 17.3183 99.7128 19.1154 99.7138 20.9579H99.7201Z",
    fill: "url(#paint0_linear_44_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.93091 29.8796L5.93091 0.123566L-2.3365e-05 0.123566L-2.3365e-05 29.8796H5.93091Z",
    fill: "url(#paint1_linear_44_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.156 12.0393V9.04214C17.156 8.24977 17.4707 7.48985 18.031 6.92956C18.5913 6.36927 19.3512 6.0545 20.1436 6.0545H34.9995V0.123566H20.1436C18.9723 0.12315 17.8124 0.353552 16.7301 0.801605C15.6479 1.24966 14.6646 1.90658 13.8363 2.73483C13.0081 3.56308 12.3511 4.54642 11.9031 5.62866C11.455 6.7109 11.2246 7.87082 11.225 9.04214V20.9579C11.2238 22.1296 11.4536 23.29 11.9013 24.3728C12.349 25.4556 13.0059 26.4395 13.8343 27.2682C14.6626 28.0968 15.6463 28.754 16.7289 29.2021C17.8115 29.6502 18.9719 29.8804 20.1436 29.8796H34.9995V23.9487H20.1436C19.351 23.9478 18.591 23.6324 18.0308 23.0716C17.4706 22.5108 17.156 21.7505 17.156 20.9579V12.0393Z",
    fill: "url(#paint2_linear_44_318)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.191 0.719193V22.3646C69.1886 24.216 68.5138 26.0035 67.2922 27.3947C66.0706 28.7859 64.3852 29.6861 62.5496 29.9278C60.714 30.1695 58.8531 29.7363 57.313 28.7087C55.7729 27.6812 54.6584 26.1292 54.1768 24.3415L54.1483 24.237L51.5091 14.3869L49.5828 7.2109V7.19506C49.4741 6.79648 49.2246 6.45084 48.8805 6.22217C48.5364 5.99351 48.1211 5.89734 47.7115 5.95149C47.302 6.00563 46.9259 6.20642 46.6531 6.51664C46.3802 6.82686 46.2291 7.22548 46.2277 7.63861V29.2808H40.2936V7.63861C40.2952 5.7869 40.9695 3.99884 42.1909 2.60706C43.4122 1.21528 45.0976 0.314546 46.9334 0.0724312C48.7692 -0.169684 50.6305 0.263302 52.171 1.29084C53.7114 2.31838 54.8262 3.8705 55.3078 5.65847L55.33 5.73767L57.9787 15.6162L59.9018 22.7923C60.0104 23.1906 60.2597 23.5361 60.6034 23.7648C60.9472 23.9934 61.3622 24.0898 61.7715 24.0361C62.1809 23.9824 62.5569 23.7822 62.83 23.4725C63.1031 23.1629 63.2548 22.7648 63.2569 22.3519V0.719193H69.191Z",
    fill: "url(#paint3_linear_44_318)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_318",
    x1: 75.9647,
    y1: 3.86525,
    x2: 98.2342,
    y2: 26.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3366FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C3AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3366FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_44_318",
    x1: 5.18512,
    y1: 1.88107,
    x2: -3.4455,
    y2: 3.34061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3366FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C3AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3366FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_44_318",
    x1: 12.6292,
    y1: 3.86525,
    x2: 34.8586,
    y2: 24.7984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3366FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C3AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3366FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_44_318",
    x1: 42.0004,
    y1: 3.77748,
    x2: 64.2615,
    y2: 29.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3366FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2C3AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2C3DFF",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#2E45FF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3054FF",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3366FF",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99.7201,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnsLogo);
export default __webpack_public_path__ + "static/media/ICNS-logo.ad728814840ff2965134c0c7a1495f24.svg";
export { ForwardRef as ReactComponent };